import authn from "./services/authn"

const discovery = {
  authn
}

export {discovery}